import { AccountType, Action, Page, Role } from "./permissions";

//This matrix is based on the Feature/Permission Matrix from google sheets. Ask for access if you need to update it.

export const permissionMatrix = {
    [AccountType.Subscriber]: {
        [Page.Clients]: {
            "clientList": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientInvite": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.MgrOps]: [],
                [Role.MgrAdmin]: [],
            },
            "clientDeactivate": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientAccountDetails": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read, Action.Update],
                [Role.MgrAdmin]: [Action.Read, Action.Update],
            },
            "clientSites": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read, Action.Update],
                [Role.MgrAdmin]: [Action.Read, Action.Update],
            },
            "clientMembersList": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientMembersInvitationManagement": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.MgrOps]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.MgrAdmin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
            },
            "clientMembersDetails": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read, Action.Update],
                [Role.MgrAdmin]: [Action.Read, Action.Update],
            },
            "clientVenueList": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueDeactivate": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueDetails": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientEngagementTerms": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientComplianceAndOperations": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueDocuments": {
                [Role.Owner]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.Admin]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueManagementSupplierInformation": {
                [Role.Owner]: [Action.Read, Action.Update],
                [Role.Admin]: [Action.Read, Action.Update],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueManagementVenueManagers": {
                [Role.Owner]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.Admin]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read, Action.Update],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueManagementAccountManager": {
                [Role.Owner]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.Admin]: [Action.Read, Action.Update, Action.Delete, Action.Create],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read, Action.Update],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueIncidentReports": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "clientVenueReportsEndOfShiftReports": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            }
        },
        [Page.Venues]: {
            "shiftRoles": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "taskChecklist": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Update, Action.Read],
                [Role.MgrOps]: [Action.Create, Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "resourceRates": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Update, Action.Read],
                [Role.MgrOps]: [Action.Update, Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "venueAccreditationRequirements": {
                [Role.Owner]: [Action.Read, Action.Update, Action.Create, Action.Delete],
                [Role.Admin]: [Action.Read, Action.Update, Action.Create, Action.Delete],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read]
            },
        },
        [Page.Suppliers]: {
              "supplierInvite": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read, Action.Update],
                [Role.MgrOps]: [],
                [Role.MgrAdmin]: [],
            },
            "supplierDetails": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
        },
        [Page.Resources]:{
            "resourceMedical": {
                [Role.Admin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
            }
        },
        [Page.AssetLibrary]: {
            "formDesigner": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Create, Action.Read, Action.Update, Action.Delete]
            },
        },
        [Page.Details]: {
             "manageSkills": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read]
            }
        },
        [Page.AccreditationV2]: {
            "accreditationRegister": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "accreditationApproval": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update],
                [Role.CoOrdin]: [],
                [Role.MgrOps]: [],
                [Role.MgrAdmin]: [],
            },
            "accreditationRequirements": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "complianceDashboard": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
            "accreditationRequests": {
                [Role.Owner]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.Admin]: [Action.Create, Action.Read, Action.Update, Action.Delete],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
        },
    },
    [AccountType.Client]: {
        [Page.Venues]: {
            "shiftRoles": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "taskChecklist": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "resourceRates": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "venueAccreditationsRequirements": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
        },
        [Page.Resources]:{
            "resourceMedical": {
                [Role.Admin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
            }
        },
        [Page.Suppliers]: {
            "supplierDetails": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            }
        },
        [Page.AccreditationV2]: {
            "accreditationRegister": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [Action.Read],
            },
            "complianceDashboard": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
            "accreditationRequests": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
        }
    },
    [AccountType.Supplier]: {
        [Page.Resources]: {
            "resourceMedical": {
                [Role.Admin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
            }
        },
        [Page.AccreditationV2]: {
            "accreditationRegister": {
                [Role.Owner]: [Action.Create, Action.Read],
                [Role.Admin]: [Action.Create, Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
            "complianceDashboard": {
                [Role.Owner]: [Action.Read],
                [Role.Admin]: [Action.Read],
                [Role.CoOrdin]: [],
                [Role.MgrOps]: [],
                [Role.MgrAdmin]: [],
            },
            "accreditationRequests": {
                [Role.Owner]: [Action.Create, Action.Read],
                [Role.Admin]: [Action.Create, Action.Read],
                [Role.CoOrdin]: [Action.Read],
                [Role.MgrOps]: [Action.Read],
                [Role.MgrAdmin]: [],
            },
        }
    }
};

export const pagePermissionMatrix: Record<
    AccountType,
    Partial<Record<Page, Role[]>>
> = {
    [AccountType.Subscriber]: {
        [Page.Home]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Clients]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Venues]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Suppliers]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Resources]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Roster]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.AttendanceRegister]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.TimesheetRegister]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.SignOnSignOff]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.IncidentReports]: [Role.Owner, Role.Admin, Role.MgrAdmin, Role.CoOrdin, Role.MgrOps],
        [Page.Details]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Members]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.AccreditationV2]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.ComplianceEligibility]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Logs]: [],
    },
    [AccountType.Client]: {
        [Page.Home]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Clients]: [],
        [Page.Venues]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Suppliers]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Resources]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Roster]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.AttendanceRegister]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.TimesheetRegister]: [],
        [Page.SignOnSignOff]: [],
        [Page.IncidentReports]: [Role.Owner, Role.Admin, Role.MgrAdmin, Role.CoOrdin, Role.MgrOps],
        [Page.Details]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Members]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.AccreditationV2]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.ComplianceEligibility]: [],
        [Page.Logs]: [],
    },
    [AccountType.Supplier]: {
        [Page.Home]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Clients]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Venues]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Suppliers]: [],
        [Page.Resources]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Roster]: [Role.Owner, Role.MgrOps, Role.Admin, Role.CoOrdin, Role.MgrAdmin],
        [Page.AttendanceRegister]: [],
        [Page.TimesheetRegister]: [],
        [Page.SignOnSignOff]: [],
        [Page.IncidentReports]: [Role.Owner, Role.Admin, Role.MgrAdmin, Role.CoOrdin, Role.MgrOps],
        [Page.Details]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.Members]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps, Role.MgrAdmin],
        [Page.AccreditationV2]: [Role.Owner, Role.Admin, Role.CoOrdin, Role.MgrOps],
        [Page.ComplianceEligibility]: [],
        [Page.Logs]: [],
    },
};